"use client";

import { useEffect } from "react";
import type { Locale } from "@/lib/i18n/types";

/**
 * Client component that syncs <html lang="..."> attribute
 * when the locale changes via URL navigation.
 */
export function LocaleHtmlLang({ locale }: { locale: Locale }) {
  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale]);

  return null;
}
